(() => {
  // カテゴリタブは現状表示切替用。アクティブ状態とインジケーター位置を同期する。
  const initTabs = () => {
    const tabs = Array.from(document.querySelectorAll('[data-shop-tab]'));
    const indicator = document.querySelector('[data-shop-tab-indicator]');

    if (tabs.length === 0 || !indicator) {
      return;
    }

    // アクティブなタブの幅と位置に合わせて下線を移動する。
    const updateIndicator = (tab) => {
      indicator.style.width = `${tab.offsetWidth}px`;
      indicator.style.transform = `translateX(${tab.offsetLeft}px)`;
    };

    tabs.forEach((tab) => {
      tab.addEventListener('click', () => {
        tabs.forEach((item) => {
          item.classList.remove('is-active');
          item.setAttribute('aria-selected', 'false');
        });

        tab.classList.add('is-active');
        tab.setAttribute('aria-selected', 'true');
        updateIndicator(tab);
      });
    });

    updateIndicator(tabs[0]);
    window.addEventListener('resize', () => updateIndicator(document.querySelector('[data-shop-tab].is-active') || tabs[0]));
  };

  // 簡易カルーセル制御。前後ボタンとドットで表示中スライドを切り替える。
  const initCarousel = () => {
    const root = document.querySelector('[data-shop-carousel]');
    if (!root) {
      return;
    }

    const slides = Array.from(root.querySelectorAll('[data-shop-carousel-slide]'));
    const dots = Array.from(root.querySelectorAll('[data-shop-carousel-dot]'));
    const prev = root.querySelector('[data-shop-carousel-prev]');
    const next = root.querySelector('[data-shop-carousel-next]');

    if (slides.length === 0) {
      return;
    }

    const autoplayDelay = 3000;
    const hasMultipleSlides = slides.length > 1;
    let current = 0;
    let autoplayTimer = null;
    let startX = null;
    let startY = null;

    // 常に1枚だけを表示対象にし、対応するドットも同時にアクティブ化する。
    const render = (index) => {
      current = (index + slides.length) % slides.length;

      slides.forEach((slide, slideIndex) => {
        slide.classList.toggle('is-active', slideIndex === current);
      });

      dots.forEach((dot, dotIndex) => {
        dot.classList.toggle('is-active', dotIndex === current);
      });
    };

    const stopAutoplay = () => {
      if (autoplayTimer === null) {
        return;
      }

      window.clearInterval(autoplayTimer);
      autoplayTimer = null;
    };

    const startAutoplay = () => {
      if (!hasMultipleSlides || document.hidden) {
        return;
      }

      stopAutoplay();
      autoplayTimer = window.setInterval(() => render(current + 1), autoplayDelay);
    };

    const restartAutoplay = () => {
      stopAutoplay();
      startAutoplay();
    };

    prev?.addEventListener('click', () => {
      render(current - 1);
      restartAutoplay();
    });

    next?.addEventListener('click', () => {
      render(current + 1);
      restartAutoplay();
    });

    dots.forEach((dot, index) => {
      dot.addEventListener('click', () => {
        render(index);
        restartAutoplay();
      });
    });

    // モバイルでは横方向のスワイプで前後移動する。
    root.addEventListener('touchstart', (event) => {
      const touch = event.touches[0];
      startX = touch?.clientX ?? null;
      startY = touch?.clientY ?? null;
    }, { passive: true });

    root.addEventListener('touchend', (event) => {
      if (startX === null || startY === null) {
        return;
      }

      const touch = event.changedTouches[0];
      const endX = touch?.clientX ?? startX;
      const endY = touch?.clientY ?? startY;
      const diffX = endX - startX;
      const diffY = endY - startY;

      startX = null;
      startY = null;

      if (Math.abs(diffX) < 40 || Math.abs(diffX) <= Math.abs(diffY)) {
        return;
      }

      render(diffX < 0 ? current + 1 : current - 1);
      restartAutoplay();
    }, { passive: true });

    document.addEventListener('visibilitychange', () => {
      if (document.hidden) {
        stopAutoplay();
        return;
      }

      startAutoplay();
    });

    render(0);
    startAutoplay();
  };

  document.addEventListener('DOMContentLoaded', () => {
    initTabs();
    initCarousel();
  });
})();
